export const EMAIL_VALIDATION_REQUEST = 'EMAIL_VALIDATION_REQUEST'
export const EMAIL_VALIDATION_SUCCESS = 'EMAIL_VALIDATION_SUCCESS'
export const EMAIL_VALIDATION_FAIL = 'EMAIL_VALIDATION_FAIL'
export const EMAIL_VALIDATION_RESET = 'EMAIL_VALIDATION_RESET'

export const EMAIL_PASSWORD_REQUEST = 'EMAIL_PASSWORD_REQUEST'
export const EMAIL_PASSWORD_SUCCESS = 'EMAIL_PASSWORD_SUCCESS'
export const EMAIL_PASSWORD_FAIL = 'EMAIL_PASSWORD_FAIL'
export const EMAIL_PASSWORD_RESET = 'EMAIL_PASSWORD_RESET'

export const EMAIL_INVITE_REQUEST = 'EMAIL_INVITE_REQUEST'
export const EMAIL_INVITE_SUCCESS = 'EMAIL_INVITE_SUCCESS'
export const EMAIL_INVITE_FAIL = 'EMAIL_INVITE_FAIL'
export const EMAIL_INVITE_RESET = 'EMAIL_INVITE_RESET'

export const EMAIL_PROJECT_NOTIFICATION_REQUEST =
  'EMAIL_PROJECT_NOTIFICATION_REQUEST'
export const EMAIL_PROJECT_NOTIFICATION_SUCCESS =
  'EMAIL_PROJECT_NOTIFICATION_SUCCESS'
export const EMAIL_PROJECT_NOTIFICATION_FAIL = 'EMAIL_PROJECT_NOTIFICATION_FAIL'
export const EMAIL_PROJECT_NOTIFICATION_RESET =
  'EMAIL_PROJECT_NOTIFICATION_RESET'

export const EMAIL_SUPPORT_REQUEST = 'EMAIL_SUPPORT_REQUEST'
export const EMAIL_SUPPORT_SUCCESS = 'EMAIL_SUPPORT_SUCCESS'
export const EMAIL_SUPPORT_FAIL = 'EMAIL_SUPPORT_FAIL'
export const EMAIL_SUPPORT_RESET = 'EMAIL_SUPPORT_RESET'
